export default {
  computed: {
    form () {
      return this.$store.getters.bookingForm
    }
  },

  methods: {
    updateBookingFormValue (value, key) {
      this.$store.commit('updateBookingFormValue', {
        key: key,
        value: value
      })
    },

    updateBookingFormBikeValue (value, key, bikeKey) {
      this.$store.commit('updateBookingFormBikeValue', {
        bikeKey: bikeKey,
        key: key,
        value: value
      })
    }
  }
}
